import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const state = {
  focus: "",
  pageNumber: 1,
  searchParameters: {},
  search: ""
}

const mutations = {
    newFocus (state, {uuid, pageNumber, searchParameters, search}) {
        state.focus = uuid;
        state.pageNumber = pageNumber;
        state.searchParameters = searchParameters;
        state.search = search;
    }
}

export default new Vuex.Store({
  state,
  mutations
})